module.exports = __webpack_public_path__ + "static/media/kid-3.1cff78b5.png";